<app-configuration-page
  title="Floating Rain Import"
  description="Import studio records from a Floating Rain export."
  [breadcrumbs]="[{ label: 'Floating Rain Import' }]">

</app-configuration-page>
